import { Check } from "lucide-react";
import { useTheme } from "../../../../../hooks/useTheme";
import SubStepBreadcrumb from "./SubStepBreadcrumb";
import { calcMaxSelectableFocusAreas } from "./utils/jdUtils";

const DURATION_OPTIONS = [30, 45, 60, 90];

const CustomStep2_RoundSetup = ({ round, onDurationChange, onSubStepNav }) => {
  const { theme } = useTheme();

  const duration = parseInt(round.duration) || 45;
  const maxFocusAreas = calcMaxSelectableFocusAreas(duration);

  return (
    <div className="space-y-6 mb-10">
      <SubStepBreadcrumb activeIndex={0} onStepClick={onSubStepNav} />

      {/* Duration */}
      <div className="flex dark:text-white text-textPrimary space-x-4 text-xl mt-10">
        <span>1.</span>
        <span>Time for Interview Round</span>
      </div>

      <div className="flex gap-4">
        {DURATION_OPTIONS.map((mins) => (
          <button
            key={mins}
            type="button"
            onClick={() => onDurationChange(mins)}
            className={`relative flex items-center justify-between px-6 py-4 rounded-lg border transition-all duration-200 ${
              duration === mins
                ? "text-white"
                : "border-gray-700/50 hover:border-gray-500 dark:text-[#CCCCCC] text-textPrimary"
            }`}
            style={
              duration === mins
                ? {
                    background:
                      theme === "dark"
                        ? "linear-gradient(#140F1C, #140F1C) padding-box, linear-gradient(to right, #3b82f6, #ec4899) border-box"
                        : "linear-gradient(#ffffff, #ffffff) padding-box, linear-gradient(to right, #ec4899, #3b82f6) border-box",
                    border: "1px solid transparent",
                  }
                : {}
            }
          >
            <span className="text-sm font-medium pr-2 dark:text-white text-textPrimary">
              {mins} Min
            </span>
            <div
              className={`h-5 w-5 rounded-full flex justify-center items-center ${
                duration === mins ? "bg-gradient-to-r from-blue-500 to-pink-500" : ""
              }`}
            >
              {duration === mins && <Check size={12} className="text-white" />}
            </div>
          </button>
        ))}
      </div>

      {/* Max focus areas hint */}
      {duration >= 10 && (
        <div className="inline-block">
          <p className="text-sm dark:text-[#f7dd88] text-textSecondary bg-yellow-50/50 dark:bg-yellow-200/25 border border-yellow-200 dark:border-yellow-200/30 rounded-md px-2 py-1">
            With {duration} min, you can select up to{" "}
            <span className="dark:text-[#FFE281] text-textPrimary font-medium">
              {maxFocusAreas} focus area{maxFocusAreas !== 1 ? "s" : ""}
            </span>{" "}
            in the next step.
          </p>
          </div>
      )}
    </div>
  );
};

export default CustomStep2_RoundSetup;
